import { apiInstance } from "shared/api";
import {
  ActData,
  ApiActsResponse,
  CheckSignActBody,
  CheckSignActResponse,
  SignActResponse,
} from "./types";

export const getActs = (): Promise<ApiActsResponse> =>
  apiInstance.get("/v1/acts").then((response) => response.data);

export const getContracts = (): Promise<ApiActsResponse> =>
  apiInstance.get("/v1/contracts").then((response) => response.data);

export const getActById = (id: string): Promise<ActData> =>
  apiInstance.get(`/v1/acts/${id}`).then((response) => response.data);

export const signActById = (
  id: string,
  params?: { provider: string },
): Promise<SignActResponse> =>
  apiInstance
    .post(`/v1/acts/${id}/sign`, params)
    .then((response) => response.data);

export const checkSignActById = (
  id: string,
  params: CheckSignActBody,
): Promise<CheckSignActResponse> =>
  apiInstance
    .post(`/v1/acts/${id}/sign-check`, params)
    .then((response) => response.data);

export const getActPdfById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/acts/${id}/download`, {
      responseType: "blob",
    })
    .then((response) => response.data);

export const downloadActById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/acts/${id}/download-archive`, {
      responseType: "blob",
    })
    .then((response) => response.data);
